import { Reveal } from "./Reveal";

export const Status = ({ items }) => (
  <section data-testid="status-strip" className="bg-white">
    <div className="mx-auto grid max-w-7xl px-6 pb-20 md:grid-cols-3 lg:px-10">
      {items.map((s, i) => (
        <Reveal key={s.k} delay={i * 0.08}>
          <div data-testid={`status-item-${i}`} className="h-full border-t border-slate-300 py-6 text-center md:px-6">
            <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-[#3B5B85]">{s.k}</p>
            <p className="mt-3 font-serif text-xl leading-snug text-[#0F2137]">{s.v}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
